import React, {createContext, useReducer} from 'react'

export const SET_DTC_MAPPING_VALIDATION_LIST = 'SET_DTC_MAPPING_VALIDATION_LIST'

const Reducer = (data, payload) => {
  switch (payload.type) {
    case SET_DTC_MAPPING_VALIDATION_LIST:
      return { ...data, list: payload.data }
    default:
      return data
  }
}

const initialState = {
  list: [],
}

const DtcMappingValidationStore = ({ children }) => {
  const [state, dispatch] = useReducer(Reducer, initialState)

  return (
    <DtcMappingValidationContext.Provider value={[state, dispatch]}>
      {children}
    </DtcMappingValidationContext.Provider>
  )
}

export const DtcMappingValidationContext = createContext(initialState)
export default DtcMappingValidationStore
